import {config} from '../config';

export default {
    getDeviceSettingsLifestyleImage: (deviceType) => config.data.lifestyleImages[deviceType]?.deviceSettingsImage,
};
